<template>
    <ImageHeader
        v-if="variant?.type === 'image'"
        :variant="variant"
        :alt="contentMeta.banner?.alt"
    >
        <template #default>
            <h1
                class="page-title py-0 my-0"
            >
                {{ contentMeta.h1 }}
            </h1>
        </template>
    </ImageHeader>
    <VideoHeader
        v-else
        :variant="variant"
    >
        <template #default>
            <h1
                class="page-title py-0 my-0"
            >
                {{ contentMeta.h1 }}
            </h1>
        </template>
    </VideoHeader>
</template>

<script lang="ts" setup>
    import type {
        BannerVariant,
        ContentMeta
    } from '~/types';
    import { useIsMobile } from '~/composables';
    import ImageHeader from '~/components/media/ImageHeader/ImageHeader.vue';
    import VideoHeader from '~/components/video/VideoHeader/VideoHeader.vue';

    const props = defineProps<{
        contentMeta: ContentMeta;
    }>();

    const { isMobile } = useIsMobile();
    const variant = computed<Nilish<BannerVariant>>(() => {
        if (!props.contentMeta.banner) {
            return null;
        }

        const { desktop, mobile } = props.contentMeta.banner;
        return (isMobile.value ? mobile : desktop) ?? desktop ?? mobile ?? null;
    });
</script>

<style lang="scss"></style>
